import { Notification } from '@/utils/helpers/notification';

const guard = async(to, from, next) => {
  const isPublic = to.matched.some(records => records.meta.publicRoute);

  if (!isPublic) {
    const hasJwt = !!sessionStorage.getItem('user');

    if (!hasJwt) {
      Notification.error({
        message: 'Parece que houve algum problema. Tente novamente mais tarde'
      });

      next('/falha-checkin');
      setTimeout(() => {
        Notification.clearAll();
      }, 3000);
    }
  }

  next();
};

export default guard;
